import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { PreviewSessionService } from '@preview/services/preview-session.service';
import { interval, map, shareReplay, startWith, Subject, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'app-preview-banner',
  templateUrl: './preview-banner.component.html',
  styleUrls: ['./preview-banner.component.scss'],
})
export class PreviewBannerComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();

  constructor(
    readonly previewSessionService: PreviewSessionService,
    readonly router: Router
  ) { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  stopPreview() {
    this.previewSessionService.stop().pipe(takeUntil(this.destroy$)).subscribe(() => {
      window.location.href = '/dashboard';
    });
  }

  get getViewedUserEmail() {
    return this.previewSessionService.getViewedUserEmail();
  }

  readonly remainingTime$ = interval(1000).pipe(
    startWith(0),
    map(() => this.previewSessionService.getRemainingTime()),
    tap((remainingTime) => {
      if (remainingTime <= 0) {
        this.stopPreview();
      }
    }),
    map((remainingTime) => this.formatRemainingTime(remainingTime)),
    takeUntil(this.destroy$),
    shareReplay({
      bufferSize: 1,
      refCount: true,
    })
  );

  private formatRemainingTime(milliseconds: number): string {
    const totalSeconds = Math.ceil(milliseconds / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return [
        hours,
        minutes.toString().padStart(2, '0'),
        seconds.toString().padStart(2, '0'),
      ].join(':');
    }

    return [
      minutes,
      seconds.toString().padStart(2, '0'),
    ].join(':');
  }
}
